import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "user_details"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "User ID :", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "User Name :", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "IP Address:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "MAC Address:", -1)
const _hoisted_6 = { class: "tw-w-full tw-grid tw-grid-cols-1 tw-items-center tw-gap-3 tw-mt-6" }

import Button from "@/core/components/ui/general/Button.vue";
import Text from "@/core/components/ui/general/Text.vue";
import tradeEstimateService from "@/core/services/trade-estimate.service";
import CommonDialog from "@/core/components/CommonDialog.vue";
import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EstimateDetailsModal',
  props: {
  projectEstimateId: {
    type: Number,
  },
},
  emits: ["on-close", "on-save"],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const props = __props;
const onClickBackButton = () => {
  emits("on-close");
};
const details = ref(null);
const loading = ref(false);
onMounted(async () => {
  try {
    loading.value = true;
    const response = await tradeEstimateService.getEstimateDigitalSignature(
      props.projectEstimateId
    );

    if (response) details.value = response.projectEstimate;
  } catch (error) {
    console.log("error", error);
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_CommonLoader = _resolveComponent("CommonLoader")!

  return (_openBlock(), _createBlock(CommonDialog, {
    class: "estimate_details_modal",
    title: "Your Digital Details",
    width: "365px",
    "max-width": "100%",
    onClickBackButton: onClickBackButton,
    isShowHeader: false
  }, {
    body: _withCtx(() => [
      _createVNode(_component_CommonLoader, { loading: loading.value }, null, 8, ["loading"]),
      (!loading.value && details.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _hoisted_2,
                _createElementVNode("span", null, _toDisplayString(details.value?.user?.id), 1)
              ]),
              _createElementVNode("li", null, [
                _hoisted_3,
                _createElementVNode("span", null, _toDisplayString(details.value?.user?.firstName), 1)
              ]),
              _createElementVNode("li", null, [
                _hoisted_4,
                _createElementVNode("span", null, _toDisplayString(details.value?.ipAddress), 1)
              ]),
              _createElementVNode("li", null, [
                _hoisted_5,
                _createElementVNode("span", null, _toDisplayString(details.value?.macAddress), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(Button, {
          variant: "tertiary",
          label: "Close",
          class: "button button-orange",
          onClick: onClickBackButton
        })
      ])
    ]),
    _: 1
  }))
}
}

})